/* eslint-disable */
import React, { Component, Fragment } from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import { Col, Row, Label, Input, Button, Container } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter,Card, CardTitle, CardBody } from 'reactstrap';
import {EditableText} from '../../../Asset/components/ClassDisplayDetail';
import {
    // loadDevice, 
    loadAssetClass,   
} from '../../../../redux/actions/mapActions';
import {
    getAssetList,
    addDashBoardLayout,
} from '../../../../redux/actions/dashboardActions';
import {
    getAttributes,
    clearAttributes,
} from '../../../../redux/actions/attributeMgmtAction';
import { toast } from "react-toastify";
import {UserContext} from '../../../../constants/myContexts';
import { isStringEmpty } from '../../../../factories/utils';
import {addDashBoardTemplateEntry} from "../../../../redux/actions/dashboardTemplateAction";

class AttrParamAddElement extends Component {
    static contextType = UserContext;
    constructor(props){
        super(props);

        console.log('props list in constructor is', this.props)
        this.state={
            currentAssetClassId: null,
            currentAssetId: null,
            currentDeviceId: null,
            currentAttrId: null,
            currentAttrName: null,
            devices: [],
        }
    }

    componentDidMount(){
        const  {userObj, updateUserObj} = this.context;
         
        this.props.loadAssetClass();
    }

    handleInputChange =(newVal) => {
        this.setState((prevState)=>{
            // if (prevState.layout){
            //     prevState.layout.name = newVal;
            //     return ({
            //         currentName: newVal,
            //         layout: prevState.layout,
            //     })
            // }else{
            //     return null;
            // }

            return ({
                currentName: newVal,
                // layout: prevState.layout,
            });
        }, ()=>{
             
             
        });
    }

    renderTitle =()=> {
        return(
            
            <Row style={{ flexGrow: 1, justifyContent: 'left', alignItems: 'left', marginBottom: 5 }}>
                <Col md={3}>
                    <Label style={{display: 'inline'}} ><h4><b> Name :</b></h4></Label>
                </Col>
                <Col md={8}>
                    {/* <Label style={{display: 'inline'}} >{this.props.fencename}</Label> */}
                    <EditableText
                         type='text'
                        //  defaultValue={this.props.layout ? this.props.layout.name : ''} 
                         defaultValue={this.state.currentName ? this.state.currentName : ''} 
                         exitOnEnterKeyPress={false}
                         onSave={newVal => {this.handleInputChange(newVal)}}
                    />
                </Col>
            </Row>           
        )
    }

    onAssetClassChange = (e) => {
         
        let assetClassId = e.target.value;
        this.setState({
            currentAssetClassId: assetClassId,
            currentAssetId: null,
            devices:[],
            currentDeviceId: null,
            currentAttrId: null,
            currentAttrName: null,
        });
        this.props.getAssetList({assetclassid: assetClassId});
        //  
        this.props.clearAttributes();
    }

    renderAssetClass = () => {
        console.log('render asset class')
        return (
            <Row>
                <Col md={3} style={{textAlign: 'left' }}>
                    <Label for="assetclass" style={{display: 'inline', width: "100%"}} ><h4><b>Asset Class</b></h4></Label>
                </Col>
                <Col md={8}>
                    <Input type="select" id="assetclass" name="assetclass" width="100%" value={this.state.currentAssetClassId} onChange={this.onAssetClassChange} >
                        {/* {this.props.assets && this.props.assets.map((asset, i) => (<option key={asset.assetid} value={asset.assetid}>{asset.assetname}</option>))} */}
                        <option value={0}>NONE</option>
                        {this.props.assetClasses && this.props.assetClasses.map((assetclass, i) => (<option key={assetclass.assetclassid} value={assetclass.assetclassid}>{assetclass.assetclassname}</option>))}
                    </Input>
                </Col>
            </Row>
        )
    }

    setDeviceList = (assets) => {
        // let devices = this.state.devices ? this.state.devices : [];
        if (assets && this.state.currentAssetId) {
            let assetObj = assets.find((asset)=>(asset.assetid == this.state.currentAssetId));
            if (assetObj) {
                let devices = assetObj.devices;
                this.setState({
                    devices: devices,
                }, () =>{
                     
                    // this.setAttrList();
                });
            }
        }
       
    }

    onAssetChange = (e) => {
        let assetId = e.target.value;
        this.setState({
            currentAssetId: assetId,
            currentDeviceId: null,
            currentAttrId: null,
            currentAttrName: null,
        }, () => {
            this.setDeviceList(this.props.assets);
        });
        this.props.clearAttributes();
    }

    renderAsset = () => {
        return (
            <Row>
                <Col md={3} style={{textAlign: 'left' }}>
                    <Label for="asset" style={{display: 'inline', width: "100%"}} ><h4><b>Asset</b></h4></Label>
                </Col>
                <Col md={8}>
                    <Input type="select" id="asset" name="asset" width="100%" value={this.state.currentAssetId} onChange={this.onAssetChange} >                                    
                        {/* {this.props.assets && this.props.assets.map((asset, i) => (<option key={asset.assetid} value={asset.assetid}>{asset.assetname}</option>))} */}
                        <option value={0}>NONE</option> 
                        {this.props.assets && this.props.assets.map((asset, i) => (<option key={asset.assetid} value={asset.assetid}>{asset.assetname}</option>))}
                    </Input>
                </Col>
            </Row>
        )
    }

    setAttrList = () => {
         
        if (this.state.devices && this.state.currentDeviceId && this.state.currentDeviceId != this.state.preiousDeviceId) {
            let deviceObj = this.state.devices.find((device)=>(device.deviceid == this.state.currentDeviceId));
            if (deviceObj) {
                this.setState({preiousDeviceId: this.state.currentDeviceId});
                this.props.getAttributes(deviceObj.devicetype);
            }
        }
    }

    onDeviceChange = (e) =>{
        let deviceId = e.target.value;
        this.setState({
            currentDeviceId: deviceId,
            currentAttrId: null,
            currentAttrName: null,
        },() =>{
            this.setAttrList();
        });
    }

    renderDevice = () => {
        //  
        // let devices = [];
        // if (this.props.assets && this.state.currentAssetId) {
        //     let assetObj = this.props.assets.find((asset)=>(asset.assetid == this.state.currentAssetId));
        //     if (assetObj) {
        //         devices = assetObj.devices;
        //     }
        // }
        return (
            <Row>
                <Col md={3} style={{textAlign: 'left' }}>
                    <Label for="device" style={{display: 'inline', width: "100%"}} ><h4><b>Device</b></h4></Label>
                </Col>
                <Col md={8}>
                    <Input type="select" id="device" name="device" width="100%" value={this.state.currentDeviceId} onChange={this.onDeviceChange} >                                    
                        {/* {this.props.assets && this.props.assets.map((asset, i) => (<option key={asset.assetid} value={asset.assetid}>{asset.assetname}</option>))} */}
                        <option value={0}>NONE</option> 
                        {/* {devices.map((device, i) => (<option key={device.deviceid} value={device.deviceid}>{device.devicename}</option>))} */}
                        {this.state.devices.map((device, i) => (<option key={device.deviceid} value={device.deviceid}>{device.devicename}</option>))}
                    </Input>
                </Col>
            </Row>
        )
    }

    onAttrChange = (e) => {
         
        let index = e.target.selectedIndex
        this.setState({
            currentAttrId: e.target.value,
            currentAttrName: e.target.options[index].text
        });
    }



    renderAttribute = () => {
         
        return (
            <Row>
                <Col md={3} style={{textAlign: 'left' }}>
                    <Label for="attribute" style={{display: 'inline', width: "100%"}} ><h4><b>Attribute</b></h4></Label>
                </Col>
                <Col md={8}>
                    <Input type="select" id="attribute" name="attribute" width="100%" value={this.state.currentAttrId} onChange={this.onAttrChange} >                                    
                        {/* {this.props.assets && this.props.assets.map((asset, i) => (<option key={asset.assetid} value={asset.assetid}>{asset.assetname}</option>))} */}
                        <option value={0}>NONE</option> 
                        {/* {devices.map((device, i) => (<option key={device.deviceid} value={device.deviceid}>{device.devicename}</option>))} */}
                        {this.props.attributes && this.props.attributes.map((attr, i) => (<option key={attr.attributeid} value={attr.attributeid}>{attr.attributename}</option>))}
                    </Input>
                </Col>
            </Row>
        )
    }

    onCancleClick = (e) => {
        this.props.toggle();
    }

    validateInput(){
        // let isValidated = true;
        let hasUser = this.context != undefined && this.context != null && this.context.userObj != undefined && this.context.userObj != null;
        if (!hasUser){
             
            toast.error("Can not get user infomation");
        }
        let isInput = !isStringEmpty(this.state.currentName) && !isStringEmpty(this.state.currentAttrName);
        let isSelect = this.state.currentAssetId != null && this.state.currentAssetId != 0 && this.state.currentDeviceId != null && this.state.currentDeviceId != 0 && this.state.currentAttrId != null && this.state.currentAttrId != 0
        if (!isInput || ! isSelect){
             
            toast.error("Input is not valid");
        }
         
         
        return hasUser && isInput;
    }

    onOkClick = (e) => {
         
        if (!this.validateInput()) {
             
            return;
        }
         
        let position = {w:3,h:7,x:8,y:8};
        let parameter = {
            assetid:this.state.currentAssetId, 
            deviceid:this.state.currentDeviceId,
            attrid:  this.state.currentAttrId, 
            attrname: this.state.currentAttrName
        };
        let layout = {
            id: 0,
            templateid: this.props.templateId,
            templatename: this.props.templateName,
            name: this.state.currentName,
            type: "AttributeValue",
            width: 9,
            locked: 0,
            display: 0,
            position: JSON.stringify(position),
            parameter: JSON.stringify(parameter),
            username: this.context.userObj.userName,
            createdby: this.context.userObj.userName,
            companycode: this.context.userObj.companyCode,
            // createdtime: "2019-02-04T03:28:50.000+0000",
            createdtime: new Date().toUTCString(),
        }

        console.log('the layout date for new template entry',layout)


       // this.props.addDashBoardLayout(layout);
        this.props.addDashBoardTemplateEntry(layout)

        this.props.toggle();
        this.props.parentToggle();
    }

    render(){
        console.log('props list in render is', this.props)
        return (
            <Card>
                <CardBody>
                    {/* <CardTitle>Set Attribute Value</CardTitle> */}
                    {this.renderTitle()}
                    <Row style={{marginBottom: '10px'}}>
                        <Col md={12}>
                            {/* {this.props.layout && this.renderParameterInput(this.props.layout.type)} */}
                            {this.renderAssetClass()}
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '10px'}}>
                        <Col md={12}>
                            {this.renderAsset()}
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '10px'}}>
                        <Col md={12}>
                            {this.renderDevice()}
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '10px'}}>
                        <Col md={12}>
                            {this.renderAttribute()}
                        </Col>
                    </Row>
                    <hr/>
                    <div style={{textAlign: 'right'}}>
                    <Button color="secondary" onClick={this.onOkClick} >OK</Button>{' '}
                    <Button color="custom" onClick={this.onCancleClick}>Cancel</Button>
                    </div>
                </CardBody>
            </Card>
        ); 
    }
}

// export default AttrParamAddElement;

function mapStateToProps(state) {
    // const types = state.mapboard.types;
    const assets = state.dashboard.assetList;
    const assetClasses = state.mapboard.assetClass;
    const attributes = state.attributemgmt.attributes;
    const props = {
        // types,  
        assetClasses,
        assets,
        attributes,
    };
    return props;
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
            // loadDevice, 
            loadAssetClass,
            getAssetList,
            getAttributes,
            clearAttributes,
            addDashBoardLayout,
        addDashBoardTemplateEntry
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AttrParamAddElement);
